import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { DatePipe, DecimalPipe, PercentPipe, JsonPipe } from '@angular/common';

// Material - TODO change this to get what we need
import { DemoMaterialModule } from './material-module';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';

// font awesome!
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

// ng-select
import { NgSelectModule } from '@ng-select/ng-select';

// Quill
import { QuillModule } from 'ngx-quill'

// PDF Viewer
import { PdfViewerModule } from 'ng2-pdf-viewer';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ViewComponent } from './view/view.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoginComponent } from './login/login.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { UserComponent } from './user/user.component';
import { HomeComponent } from './home/home.component';
import { ArchitectureComponent } from './architecture/architecture.component';
import { EntityComponent } from './architecture/entity/entity.component';
import { EntityEditComponent } from './architecture/entity-edit/entity-edit.component';
import { TableComponent } from './table/table.component';
import { TableGridComponent } from './table/table-grid/table-grid.component';
import { TableGridAsyncComponent } from './table/table-grid-async/table-grid-async.component';
import { TableReportComponent } from './table/table-report/table-report.component';
import { AdminComponent } from './admin/admin.component';
import { TableEditComponent } from './table/table-edit/table-edit.component';
import { DigitOnlyDirective } from './digit-only.directive';
import { DigitAndXOnlyDirective } from './digit-x-only.directive';
import { SectionEditComponent } from './architecture/section-edit/section-edit.component';
import { PowerbiComponent } from './powerbi/powerbi.component';
import { VersionsComponent } from './architecture/versions/versions.component';
import { HelpPdfComponent } from './help-pdf/help-pdf.component';
import { UserAdminComponent } from './admin/user-admin/user-admin.component';
import { UserAdminAccountComponent } from './admin/user-admin/user-admin-account/user-admin-account.component';
import { UserAdminEditComponent } from './admin/user-admin/user-admin-edit/user-admin-edit.component';
import { SlUseCasesComponent } from './architecture/sl-use-cases/sl-use-cases.component';
import { SlViewComponent } from './architecture/sl-view/sl-view.component';
import { SlAssetMapComponent } from './architecture/sl-asset-map/sl-asset-map.component';
import { ArchitecturePrintComponent } from './architecture/architecture-print/architecture-print.component';
import { ChangelogComponent } from './changelog/changelog.component';
import { ImportDialogComponent } from './architecture/import-dialog/import-dialog.component';
import { LogoManagerComponent } from './logo-manager/logo-manager.component';
import { LogoAdminComponent } from './admin/logo-admin/logo-admin.component';

import { AuthInterceptor } from './http-interceptors/auth-interceptor';
import { FAQComponent } from './faq/faq.component';
import { NotesEditComponent } from './architecture/notes-edit/notes-edit.component';
import { AccountFilteringComponent } from './architecture/account-filtering/account-filtering.component'
import { MultiSelectionComponent } from './multi-selection/multi-selection.component' 
import { MaskDialog } from './mask/mask-dailog.component'
import { EventEditComponent } from './architecture/event-edit/event-edit.component';
import { SubAccountComponent } from './architecture/sub-account/sub-account.component';
import { AdminReportsComponent } from './admin/admin-reports/admin-reports.component';
import { StackColorComponent } from './admin/stack-color/stack-color.component';
import { StackColorEditComponent } from './admin/stack-color/stack-color-edit/stack-color-edit.component';
import { FeedbackComponent } from './feedback/feedback.component';

import { AuthGuardService } from './services/auth-guard.service';
import { VoiceOfCustomerComponent } from './architecture/voice-of-customer/voice-of-customer.component';

import { SlViewNewComponent } from './architecture/sl-view-new/sl-view-new.component';
import { EntityNewComponent } from './architecture/entity-new/entity-new.component';
import { GetPowerBIComponent } from './get-power-bi/get-power-bi.component';
import { SlAssetMapNewComponent } from './architecture/sl-asset-map-new/sl-asset-map-new.component';

import { IframeComponent } from './iframe/iframe.component';

import { LoginRedirectComponent } from './login-redirect/login-redirect.component';

@NgModule({
  declarations: [
    AppComponent,
    ViewComponent,
    LoginComponent,
    PageNotFoundComponent,
    UserComponent,
    HomeComponent,
    ArchitectureComponent,
    EntityComponent,
    EntityEditComponent,
    TableComponent,
    TableGridComponent,
    TableGridAsyncComponent,
    TableReportComponent,
    AdminComponent,
    TableEditComponent,
    DigitOnlyDirective,
    DigitAndXOnlyDirective,
    SectionEditComponent,
    PowerbiComponent,
    VersionsComponent,
    HelpPdfComponent,
    UserAdminComponent,
    UserAdminAccountComponent,
    UserAdminEditComponent,
    SlUseCasesComponent,
    SlViewComponent,
    SlAssetMapComponent,
    ArchitecturePrintComponent,
    ChangelogComponent,
    ImportDialogComponent,
    LogoManagerComponent,
    LogoAdminComponent,
    FAQComponent,
    NotesEditComponent,
    AccountFilteringComponent,
    MultiSelectionComponent,
    MaskDialog,
    EventEditComponent,
    SubAccountComponent,
    AdminReportsComponent,
    StackColorComponent,
    StackColorEditComponent,
    FeedbackComponent,
    VoiceOfCustomerComponent,
    SlViewNewComponent,
    EntityNewComponent,
    GetPowerBIComponent,
    SlAssetMapNewComponent,
    IframeComponent,
    LoginRedirectComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    DemoMaterialModule,
    HttpClientModule,
    NgSelectModule,
    BrowserAnimationsModule,
    FontAwesomeModule,
    QuillModule.forRoot(),
    PdfViewerModule
  ],
  providers: [
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
    DatePipe,
    DecimalPipe,
    PercentPipe,
    JsonPipe,
    AuthGuardService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
